import { render, staticRenderFns } from "./LtMsgBox.vue?vue&type=template&id=58eb1615&scoped=true"
import script from "./LtMsgBox.vue?vue&type=script&lang=js"
export * from "./LtMsgBox.vue?vue&type=script&lang=js"
import style0 from "./LtMsgBox.vue?vue&type=style&index=0&id=58eb1615&prod&lang=scss"
import style1 from "./LtMsgBox.vue?vue&type=style&index=1&id=58eb1615&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eb1615",
  null
  
)

export default component.exports